import type { BoltConfiguration } from '../../types';
import type { BoltConfigurationInput } from '../../services/boltParameterSetup';

function getConfigurationFieldValue(
  field: { value?: string | null } | string | null | undefined
): string {
  return typeof field === 'string' ? field : field?.value ?? '';
}

export function toBoltConfigurationInput(
  config: BoltConfiguration,
  discriminator: {
    parameterName: string;
    bindingKind: 'type' | 'instance';
  }
): BoltConfigurationInput {
  return {
    objectTypeParameterName: String(discriminator.parameterName ?? '').trim(),
    objectTypeBindingKind: discriminator.bindingKind,
    parameterDestination: config.parameterDestination,
    parameterBindingKind: config.parameterBindingKind,
    projectParameterCategories: config.projectParameterCategories,
    boltModelingChoice: getConfigurationFieldValue(config.boltModelingChoice),
    boltSetActiveValue: getConfigurationFieldValue(config.boltSetActiveValue),
    boltItemDescriptionValue: getConfigurationFieldValue(config.boltItemDescriptionValue),
    boltDiaValue: getConfigurationFieldValue(config.boltDiaValue),
    boltQuantityValue: getConfigurationFieldValue(config.boltQuantityValue),
    boltLengthValue: getConfigurationFieldValue(config.boltLengthValue),
    boltMaterialValue: getConfigurationFieldValue(config.boltMaterialValue),
    boltStandardValue: getConfigurationFieldValue(config.boltStandardValue),
  };
}
